import { jsx as _jsx } from "react/jsx-runtime";
import { getChromelessBottomSheetBodyClassName } from '#pplx/frontend/aether/components/Modal/internal/ModalInternals.js';
import { useModalLayout } from '#pplx/frontend/aether/components/Modal/internal/ModalLayoutContext.js';
import { ModalScrollableBody } from '#pplx/frontend/aether/components/Modal/internal/ModalScrollableBody.js';
/**
 * Scrollable body section of a modal. Content inside `Modal.Body` scrolls when
 * it overflows while the header and footer remain fixed.
 *
 * Must be rendered as a direct child of `<Modal>`.
 *
 * @example
 * ```tsx
 * <Modal title="Edit" onClose={onClose}>
 *   <Modal.Body>
 *     <form>...</form>
 *   </Modal.Body>
 *   <Modal.Footer>
 *     <Button>Save</Button>
 *   </Modal.Footer>
 * </Modal>
 * ```
 */
export function ModalBody({ children }) {
    const { isMobile, chromeless, hasFooter } = useModalLayout();
    // Padding is owned by the modal panel (see `ModalContent`). The body adds
    // none of its own — the only exception is chromeless mobile modals, which
    // need a small gap between body and footer when one is rendered.
    if (isMobile && chromeless) {
        return (_jsx(ModalScrollableBody, { className: getChromelessBottomSheetBodyClassName({ hasFooter }), children: children }));
    }
    return _jsx(ModalScrollableBody, { children: children });
}
//# sourceMappingURL=ModalBody.js.map